module.exports = __webpack_public_path__ + "img/LOGO_ACY.808ca871.svg";